module.exports = __webpack_public_path__ + "images/c66bd253979e933e561d4221d2fbecbe-logo_dark.png";